import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import { Row, Col, Form, Card, Button, Table } from "react-bootstrap";
import axios from "axios";
import { AutoComplete, Divider } from "rsuite";
import classes from "./Inventory.module.css";
import YesAndNoModal from "./Modals/YesAndNoModal.jsx";
import EditInventoryModal from "./Modals/EditInventoryModal.jsx";
import PermissionContext from "../../Store/permission-context";
import ProcessingModal from "./Modals/ProcessingModal";
const Inventory = () => {
  const [AxiosError, setAxiosError] = useState("");
  const [AllInventoryRecords, setAllInventoryRecords] = useState([]);
  const [Itemname, setItemname] = useState("");
  const [AllGoodNames, setAllGoodNames] = useState("");
  const [Reload, setReload] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [SentRecord, setSentRecord] = useState({});
  const [GoodToDelete, setGoodToDelete] = useState({});
  const [ShowYesModal, setShowYesModal] = useState(false);
  const [Message, setMessage] = useState("");
  const [ShowProcessing, setShowProcessing] = useState(true);
  const PCtx = useContext(PermissionContext);

  useEffect(() => {
    const getData = async () => {
      let AllInventory = await PCtx.connectAxios("getinventoryrecords.php", "");
      console.log(AllInventory);
      if (AllInventory.allrecords) {
        setAllInventoryRecords(AllInventory.allrecords);
        setAllGoodNames(AllInventory.NamesOnly);
      }

      setShowProcessing(false);
    };
    getData();
  }, [Reload]);

  useEffect(() => {
    if (AllInventoryRecords.length > 0) {
      setShowProcessing(false);
    }
  }, [AllInventoryRecords]);

  const getItemnameSelection = async (it) => {
    let goodproperties = await PCtx.connectAxios("getinventoryrecords.php", it);
    setAllInventoryRecords(goodproperties.allrecords);
  };

  const getTypedText = () => {
    let ITN = Itemname.charAt(0).toUpperCase() + Itemname.slice(1);
    if (AllGoodNames.includes(ITN)) {
      getItemnameSelection(ITN);
    } else {
      if (ITN === "") {
        setReload(!Reload);
      }
    }
  };

  const cancelModal = () => {
    setshowModal(false);
  };

  const SaveNewRecord = async (NR) => {
    let TheRecord = {
      NewRecord: NR,
      OldRecord: SentRecord,
      Staff: PCtx.Username,
    };
    // console.log(TheRecord);
    let Response = await PCtx.connectAxios(
      "updateinventoryrecords.php",
      TheRecord,
    );

    if (Response.includes("Success")) {
      setshowModal(false);
      setReload(!Reload);
      PCtx.displayAlert(
        "SUCCESS",
        "The " +
          NR.Itemname +
          " properties has been edited successfully and the inventory has been reloaded",
        "success",
      );
    } else {
      PCtx.displayAlert(
        "ERROR",
        "The " +
          NR.Itemname +
          " properties could not be saved. Please contact the administartor",
        "success",
      );
    }
  };

  const NextEvent = () => {
    setShowYesModal(false);
  };

  const bringModal = (ir, ind) => {
    setSentRecord(ir);
    setshowModal(true);
  };

  const ShowYesAndNoModal = (ir) => {
    setGoodToDelete(ir.Itemname);
    setMessage(
      "Are you sure you want to delete " +
        ir.Itemname +
        " from the stock list?",
    );
    setShowYesModal(true);
  };

  const setTheItemname = (e) => {
    e = e.toUpperCase();
    setItemname(e);
  };

  const DeleteRecord = async () => {
    let response = await PCtx.connectAxios("deletegood.php", GoodToDelete);
    if (response.includes("Success")) {
      setShowYesModal(false);
      setReload(!Reload);
      PCtx.displayAlert(
        "SUCCESS",
        "The " + GoodToDelete + " has been deleted successfully",
        "success",
      );
    } else {
      PCtx.displayAlert(
        "ERROR",
        "The " +
          GoodToDelete +
          " cannot be deleted. Please contact the administrator",
        "success",
      );
    }
  };

  return (
    <Row className="justify-content-center">
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">INVENTORY</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col md={12} sm={12} xs={12}>
        <p
          className="text-center"
          style={{
            fontFamily: "Times New Roman",
            color: "brown",
            fontSize: "25px",
          }}
        >
          STATE OF INVENTORY AS AT{" "}
          {new Date().toDateString().toUpperCase() +
            ", " +
            new Date().toLocaleTimeString().toUpperCase()}
        </p>
      </Col>
      <hr />
      <Col md={10} sm={12} xs={12}>
        <Form>
          <Form.Group>
            <Form.Label style={{ color: "brown" }}>Search for</Form.Label>

            <AutoComplete
              data={AllGoodNames}
              value={Itemname.charAt(0).toUpperCase() + Itemname.slice(1)}
              onChange={setItemname}
              onSelect={getItemnameSelection}
              onBlur={getTypedText}
              style={{ border: "1px solid brown" }}
              placeholder="Enter Item Name to search for"
            />
          </Form.Group>
        </Form>
      </Col>

      <Col md={12} sm={12} xs={12}>
        <Row>
          <Col md={12} sm={12} xs={12}></Col>
          <Col md={12} sm={12} xs={12}>
            <Table
              striped
              bordered
              responsive
              hover
              style={{ fontFamily: "Times New Roman" }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    SN
                  </th>
                  <th
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Item Name
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Bulk
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Bulk Left
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Unit Left
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Bulk/Unit
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Cost Price
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Bulk S.Price 1
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Bulk S.Price 2
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Bulk S.Price 3
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Unit S.Price 1
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Unit S.Price 2
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Unit S.Price 3
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Total Cost Price
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Total Selling Price
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Estimated Profit
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Reset
                  </th>
                  <th
                    className="text-center"
                    style={{
                      position: "sticky",
                      top: "-1px",
                      backgroundColor: "brown",
                      color: "white",
                    }}
                  >
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {AllInventoryRecords.map((invrec, index) => (
                  <tr key={index}>
                    <td>
                      {index === AllInventoryRecords.length - 1
                        ? ""
                        : index + 1}
                    </td>
                    <td>{invrec.Itemname}</td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : "text-center"
                      }
                    >
                      {index === AllInventoryRecords.length - 1
                        ? ""
                        : invrec.SoldIn}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssQ
                      }
                    >
                      {index === AllInventoryRecords.length - 1
                        ? ""
                        : invrec.QuantityLeft}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssQ
                      }
                    >
                      {index === AllInventoryRecords.length - 1
                        ? ""
                        : invrec.UnitLeft}
                    </td>
                    <td className="text-center">
                      {index === AllInventoryRecords.length - 1
                        ? ""
                        : invrec.Converter}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : "text-center"
                      }
                    >
                      {invrec.CostPrice === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.CostPrice
                        : "₦" + invrec.CostPrice}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssBSP
                      }
                    >
                      {invrec.BSP1 === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.BSP1
                        : "₦" + invrec.BSP1}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssBSP
                      }
                    >
                      {invrec.BSP2 === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.BSP2
                        : "₦" + invrec.BSP2}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssBSP
                      }
                    >
                      {invrec.BSP3 === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.BSP3
                        : "₦" + invrec.BSP3}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssUSP
                      }
                    >
                      {invrec.USP1 === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.USP1
                        : "₦" + invrec.USP1}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssUSP
                      }
                    >
                      {invrec.USP2 === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.USP2
                        : "₦" + invrec.USP2}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssUSP
                      }
                    >
                      {invrec.USP3 === "-" ||
                      index === AllInventoryRecords.length - 1
                        ? invrec.USP3
                        : "₦" + invrec.USP3}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssTotal
                      }
                    >
                      {"₦" + invrec.TotalCostPrice}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssTotal
                      }
                    >
                      {"₦" + invrec.TotalSellingPrice}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : classes.tablecssTotal
                      }
                    >
                      {"₦" + invrec.TotalProfit}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : "text-center"
                      }
                    >
                      {index < AllInventoryRecords.length - 1 && (
                        <Button
                          variant="info"
                          className="btn-sm"
                          onClick={() => bringModal(invrec, index)}
                        >
                          Edit
                        </Button>
                      )}
                    </td>
                    <td
                      className={
                        index === AllInventoryRecords.length - 1
                          ? classes.TableGrandTotal
                          : "text-center"
                      }
                    >
                      {index < AllInventoryRecords.length - 1 && (
                        <Button
                          variant="danger"
                          className="btn-sm"
                          onClick={() => ShowYesAndNoModal(invrec, index)}
                        >
                          -
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Col>
      {showModal && (
        <EditInventoryModal
          cancelModal={cancelModal}
          Invrec={SentRecord}
          show={showModal}
          SaveNewRecord={SaveNewRecord}
        />
      )}
      {ShowYesModal && (
        <YesAndNoModal
          showmodal={ShowYesModal}
          message={Message}
          modaltype="Error"
          deletereceipt={DeleteRecord}
          NextEvent={NextEvent}
        />
      )}
      {ShowProcessing && (
        <ProcessingModal
          Show={ShowProcessing}
          message="The system is retrieving your Inventory Status"
        />
      )}
    </Row>
  );
};

export default Inventory;
